export default __webpack_public_path__ + "static/media/Etape2_ButteduBuisson_After_Filtre.acf36878.jpg";